export const SET_SEPARATE_PRODUCTS = (state, value) => {
  state.separateProducts = value;
};

export const SET_PRODUCTS_LIST = (state, products) => {
  state.products = products;
};

export const SET_SECTORS_LIST = (state, sectors) => {
  state.sectors = sectors;
};

export const SET_NOSECTOR_LIST = (state, data) => {
  state.noSectorList = data;
};

export const SET_ORDER_DETAILS = (state, data) => {
  state.orderDetails = data;
};

export const SET_SHOW_SEAT_MAP = (state, data) => {
  state.showSeatMap = data;
};

export const SET_COUPON_CARD = (state, data) => {
  state.couponCard = data;
};

export const SET_ALERT_SECTORS = (state, data) => {
  state.alertSectors = data;
};

export const SET_HOVER_SHAPE = (state, data) => {
  state.hoverShape = data;
};

export const SET_SELECTED_SECTOR = (state, data) => {
  state.selectedSector = data;
};

export const SET_SELECTED_SEAT = (state, data) => {
  state.selectedSeat = data;
};

export const SET_LIST_SEATS = (state, data) => {
  state.listSeats = data;
};

export const SET_ERROR_PRODUCTS = (state, data) => {
  state.errorProducts = data;
};

export const SET_LAST_ORDER_AND_CART = (state, data) => {
  state.lastOrderAndCart = data;
};

export const SET_COUPON_DETAILS = (state, data) => {
  state.couponDetails = data;
};

export const SET_PRODUCTS_DETAILS = (state, data) => {
  state.productsDetails = data;
};

export const SET_CART_ABANDONED = (state, data) => {
  state.cartAbandoned = data;
};

export const SET_TIME_TO_VIEW_PRODUCTS = (state, data) => {
  state.timeToViewProducts = data;
};

export const SET_COUPON_APPLIED = (state, data) => {
  state.couponApplied = data;
};

export const SET_MAX_PRODUCTS_PER_CPF = (state, data) => {
  state.maxProductsPerCpf = data;
};

export const SET_SHOW_PRE_SALE = (state, data) => {
  state.showPreSale = data;
};

export const SET_SCREEN_TIME_ON = (state, data) => {
  state.screenTimeOn = data;
};

export const SET_MAX_PRODUCTS_PER_COUPON = (state, data) => {
  state.maxProductsPerCoupon = data;
};

export const SET_CHOSEN_SECTOR = (state, data) => {
  state.chosenSector = data;
};

export const SET_FACEBOOK_COOKIES = (state, data) => {
  state.facebookCookies = data;
};

export const ADD_CART_PRODUCT = (state, product) => {
  if (state.selectedSector && state.showSeatMap) {
    let record = false;
    if (!record)
      record = state.selectedSector.products.find(
        (v) =>
          `${v.codigo_produto}-${v.codigo_tipo}` ===
          `${product.codigo_produto}-${product.codigo_tipo}`
      );
    if (record) {
      if (!record.seats) record.seats = [];
      if (!record.codes) record.codes = [];
      if (!record.objsSeats) record.objsSeats = [];
      record.objsSeats.push(state.selectedSeat);
      record.seats.push(state.selectedSeat.codigo_assento);
      record.codes.push(state.selectedSeat.codigo_obj);
      record.quantidade++;
    } else {
      product.quantidade = 1;
      const idx = state.selectedSector.products
        .map((v, i) => {
          if (v[i].codigo_produto === product.codigo_produto) {
            return i;
          }
        })
        .filter((v) => v >= 0);
      state.selectedSector.products[idx].push(product);
    }
  } else {
    let record = false;
    state.noSectorList.forEach((p) => {
      if (!record)
        record = p.find(
          (v) =>
            `${v.codigo_produto}-${v.codigo_tipo}` ===
            `${product.codigo_produto}-${product.codigo_tipo}`
        );
    });
    if (record) {
      record.quantidade++;
    } else {
      product.quantidade = 1;

      const idx = state.noSectorList
        .map((v, i) => {
          if (v[i].codigo_produto === product.codigo_produto) {
            return i;
          }
        })
        .filter((v) => v >= 0);
      state.noSectorList[idx[0]].push(product);
    }
  }
};

export const REMOVE_CART_PRODUCT = (state, product) => {
  if (state.selectedSector) {
    let record = false;
    if (!record)
      record = state.selectedSector.products.find(
        (v) =>
          `${v.codigo_produto}-${v.codigo_tipo}` ===
          `${product.codigo_produto}-${product.codigo_tipo}`
      );
    if (record) {
      record.seats.splice(record.seats.indexOf(record.codigo_assento), 1);
      record.codes.splice(record.codes.indexOf(record.codigo_obj), 1);
      record.quantidade--;
    }
  } else {
    let record = false;
    state.noSectorList.forEach((p) => {
      if (!record)
        record = p.find(
          (v) =>
            `${v.codigo_produto}-${v.codigo_tipo}` ===
            `${product.codigo_produto}-${product.codigo_tipo}`
        );
    });
    if (record) {
      record.quantidade--;
    }
  }
};
